import React, { Component } from "react";
import { SwipeableDrawer } from "@material-ui/core";
import { connect } from "react-redux";

import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

class DineSuperbContent extends Component {
  render() {
    const { onClose, language, dineSuperbBranches } = this.props;

    const buttonsStyle = {
      paddingTop: 20,
      paddingBottom: 20,
      textTransform: "none",
    };
    return (
      <div className="w-100">
        <SwipeableDrawer
          anchor="bottom"
          open={true}
          onClose={() => onClose()}
          PaperProps={{
            style: { minHeight: 225, height: "auto" },
            className: "text-center w-100",
          }}
          onBackdropClick={() => onClose()}
        >
          <div>
            <span
              style={{
                position: "absolute",
                top: 15,
                right: language == "english" && 15,
                left: language == "arabic" && 15,
              }}
            >
              <CloseIcon
                onClick={() => onClose()}
                style={{ color: "#565656" }}
              />
            </span>
            <h2
              className={"mx-auto ".concat(
                language == "english" ? "text-left" : "text-right"
              )}
              style={{
                width: "90%",
                marginTop: 25,
                fontSize: "1.2rem",
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
              }}
            >
              {language == "english" ? "Select a branch" : "اختر فرع"}
            </h2>

            <div style={{ marginBottom: 60, marginTop: 35 }}>
              <ButtonGroup
                orientation="vertical"
                color="primary"
                aria-label="vertical outlined primary button group"
                style={{ width: "92%" }}
              >
                {dineSuperbBranches.map((branch) => (
                  <Button
                    style={buttonsStyle}
                    onClick={() => {
                      let win = window.open(branch.link_dinesuperb, "_blank");
                      win.focus();
                    }}
                  >
                    {language == "english"
                      ? branch.name
                      : branch.ar_name || branch.name}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
            <div style={{ height: 50 }}></div>
            <Button
              className="mt-2 mb-1"
              variant="contained"
              color="primary"
              style={{
                width: "92%",
                height: 50,
                position: "absolute",
                bottom: 15,
                left: 0,
                right: 0,
                margin: "auto",
              }}
              disableElevation
              onClick={() => onClose()}
            >
              {language == "english" ? "Close" : "اغلاق"}
            </Button>
          </div>
        </SwipeableDrawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DineSuperbContent);
